<template>
	<JBox class="s-w-full s-h-full s-overflow-y-scroll">
		<JDraggable v-model="internalUi" v-bind="draggableSettings" class="s-w-full s-pb-64 s-p-2" @change="patchComponent">
			<UiEditorLayoutNode
				v-for="node in internalUi"
				:key="node.id"
				:node="node"
				:draggableSettings="draggableSettings"
				@node:click="selectNode"
				@nodeExpand:click="toggleExpandNode"
				@node:mouseover="hoverNode"
				@node:mouseleave="hoverNode(null)"
				@nodeDrag:change="patchComponent"
			/>
		</JDraggable>
	</JBox>
</template>

<script>
import UiEditorLayoutNode from "./UiEditorLayoutNode"
import { deepClone } from "@/utils/"

export default {
	components: { UiEditorLayoutNode },

	data() {
		return {
			selectedComponentId: "",
			internalUi: [],

			// Settings for draggable nodes
			draggableSettings: {
				group: "layout",
				"ghost-class": "s-opacity-50",
				animation: 250,
				easing: "cubic-bezier(1, 0, 0, 1)",
				fallbackOnBody: true,
				swapThreshold: 0.1, // recommended was 75 but less means more precision
				handle: ".draggable-handle"
			}
		}
	},

	methods: {
		selectNode(node) {
			this.$store.dispatch("uiEditor/selectNode", node.id)
		},

		hoverNode(node) {
			this.$store.dispatch("uiEditor/hoverNode", node?.id)
		},

		toggleExpandNode(node) {
			this.$store.dispatch("uiEditor/toggleExpandNode", node?.id)
		},

		expandAllNodes() {
			this.$store.dispatch("uiEditor/expandAllNodes")
		},

		patchComponent() {
			const payload = {
				componentId: this.selectedComponentId,
				value: deepClone(this.internalUi),
				property: "editorAst"
			}
			this.$store.dispatch("uiEditor/patchComponent", payload)
		},

		init() {
			const selectedComponent = this.$store.getters["uiEditor/selectedComponent"]
			this.selectedComponentId = selectedComponent.id
			this.internalUi = deepClone(selectedComponent?.editorAst ?? [])
		}
	},

	watch: {
		"$store.state.uiEditor.selectedComponentId": {
			handler() {
				this.init()
			},
			immediate: true,
			deep: true
		},
		"$store.state.uiEditor.app.components": {
			handler() {
				this.init()
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
